import React from "react";

export interface IconCircleChevronUpProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  fill?: string;
}

export const IconCircleChevronUp: React.FC<IconCircleChevronUpProps> = ({
  width = 32,
  height = 32,
  fill = "#006231",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 28.7992C23.07 28.7992 28.7999 23.0692 28.7999 15.9992C28.7999 8.92922 23.07 3.19922 16 3.19922C8.92995 3.19922 3.19995 8.92922 3.19995 15.9992C3.19995 23.0692 8.92995 28.7992 16 28.7992ZM22.0499 16.7492C22.52 17.2192 22.52 17.9792 22.0499 18.4442C21.58 18.9092 20.82 18.9142 20.3549 18.4442L16.005 14.0942L11.655 18.4442C11.185 18.9142 10.425 18.9142 9.95995 18.4442C9.49495 17.9742 9.48995 17.2142 9.95995 16.7492L15.15 11.5492C15.62 11.0792 16.38 11.0792 16.8449 11.5492L22.0499 16.7492Z"
      fill={fill}
    />
  </svg>
);
